"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _CustomButton = _interopRequireDefault(require("../../assets/Theme9/CustomButton.css"));

var _Level = _interopRequireDefault(require("./Level1"));

var _bind = _interopRequireDefault(require("classnames/bind"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var cx = _bind["default"].bind(_CustomButton["default"]);

var CustomButton = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(CustomButton, _React$PureComponent);

  function CustomButton() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = CustomButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        customButton = _this$props.customButton,
        language = _this$props.language,
        handleClick = _this$props.handleClick,
        ui = _this$props.ui,
        onClickGroup = _this$props.onClickGroup,
        activityGroups = _this$props.activityGroups;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: cx("ButtonTheme9Wp")
    }, customButton.slice(0, 10).map(function (item, index) {
      return /*#__PURE__*/_react["default"].createElement(_Level["default"], {
        index: index,
        onClickGroup: onClickGroup,
        activityGroups: activityGroups,
        ui: ui,
        key: index,
        item: item,
        handleClick: handleClick,
        language: language
      });
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: cx("ButtonTheme9Divider")
    }));
  };

  return CustomButton;
}(_react["default"].PureComponent);

var _default = CustomButton;
exports["default"] = _default;
module.exports = exports.default;